// @flow

import { type UserInputValidationError, VALID } from '@tectonics/prs/validation';

export function validateMexicanAddress(addressValue: string): ?UserInputValidationError {
  return addressValue && addressValue.length > 0 ? VALID : { id: 'empty' };
}
